import { render, staticRenderFns } from "./RelayAddReferents.vue?vue&type=template&id=bc016b76&scoped=true&"
import script from "./RelayAddReferents.vue?vue&type=script&lang=ts&"
export * from "./RelayAddReferents.vue?vue&type=script&lang=ts&"
import style0 from "./RelayAddReferents.vue?vue&type=style&index=0&id=bc016b76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc016b76",
  null
  
)

export default component.exports